const spacing = (units) => {
  return `${units * 8}px`;
};

export default spacing;
